/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Log/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import LineWithDot from './LineWithDot/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Log({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/CommentsLogs/Logs/Content/Content/Log"
  
}) {
let auditLogItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'audit_log_item',
path: 'isFirst',
})
let auditLogItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'audit_log_item',
path: 'isLast',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let auditLogValueData = fromData.useDataFormat({ viewPath,
context: 'audit_log',
format: fromHelpers.getLog,
})
  return (<React.Fragment
>
<div
  data-testid="Log.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<LineWithDot
  viewPath={`${viewPath}/LineWithDot`}
 data="audit_log_item.isFirst"
 isFirst={auditLogItemIsFirstValueData}
 data="audit_log_item.isLast"
 isLast={auditLogItemIsLastValueData}
/>
<div
  data-testid="Log.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-kzp': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="audit_log"
 format="helpers.js getLog"
 text={auditLogValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}